import { Injectable } from '@angular/core';
import { IconConstants } from 'cc-common';

@Injectable({
    providedIn: 'root'
})
export class FileHelperService {
    getFileType(file: any): string {
        let fileType: string;
        if (file.type === 'pdf') {
            fileType = IconConstants.PDF_FILE;
        } else if (file.type === 'doc' || file.type === 'docx') {
            fileType = IconConstants.DOCS;
        } else if (file.type === 'xlsx') {
            fileType = IconConstants.XLSX;
        } else if (file.type === 'pptx') {
            fileType = IconConstants.PPTX;
        } else if (file.type === 'png') {
            fileType = IconConstants.PNG;
        } else if (file.type === 'jpg' || file.type === 'jpeg') {
            fileType = IconConstants.JPEG;
        } else if (file.type === 'gif') {
            fileType = IconConstants.GIF;
        } else if (file.type === 'txt') {
            fileType = IconConstants.TEXT;
        }
        return fileType;
    }

    getFileIcon(fileName: string): string {
        let fileType: string;
        if (fileName.includes('.pdf')) {
            fileType = IconConstants.PDF_FILE_GRID;
        } else if (fileName.includes('.doc') || fileName.includes('.docx')) {
            fileType = IconConstants.DOCS;
        } else if (fileName.includes('.xlsx')) {
            fileType = IconConstants.XLSX;
        } else if (fileName.includes('.pptx')) {
            fileType = IconConstants.PPTX;
        } else if (fileName.includes('.png')) {
            fileType = IconConstants.PNG;
        } else if (fileName.includes('.jpg') || fileName.includes('.jpeg')) {
            fileType = IconConstants.JPEG;
        } else if (fileName.includes('.gif')) {
            fileType = IconConstants.GIF;
        } else if (fileName.includes('.txt')) {
            fileType = IconConstants.TEXT;
        }
        return fileType;
    }
}
